import { SupernovaApiClient } from "@supernova-studio/client"

export class UserService {
  constructor(private readonly client: SupernovaApiClient) {}

  getMe() {
    return this.client.users.getMe()
  }
}
